export default {
    buttonTexts: {
        save: "Save",
        cancel: "Cancel",
        update: "Update",
    },
    select: {
        defaultOption: "-- Please select --",
    },
    validationErrors: {
        mixed: {
            required: "Required field.",
        },
        string: {
            email: "Please enter a valid e-mail address.",
        },
        number: {
            requiredTypeError: "Required field.",
        },
        maxLength: "Please enter no more than {{maxLength}} characters.",
    },
    unexpectedError: "An unexpected error occurred.",
};
